<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";
import MagnitIcon from "@magnit/icons/src/assets/icons/logo-main-magnit-16-colored-background-invert.svg";
import CosmeticIcon from "@magnit/icons/src/assets/icons/logo-cosmetic-16-colored-background-invert.svg";
import AptekaIcon from "@magnit/icons/src/assets/icons/logo-apteka-16-colored-background-invert.svg";
import MarketIcon from "@magnit/icons/src/assets/icons/logo-market-16-colored-background-invert.svg";
import { MenuItems } from "./VNavigation.vars";
import type { INavigationLinkProps } from "./VNavigation.types";

const PRODUCT_ICONS = {
  [MenuItems.MAGNIT]: MagnitIcon,
  [MenuItems.MARKET]: MarketIcon,
  [MenuItems.COSMETIC]: CosmeticIcon,
  [MenuItems.APTEKA]: AptekaIcon,
};

defineProps<INavigationLinkProps>();
</script>

<template>
  <div
    :class="['pl-navigation-link', { 'pl-navigation-link__active': active }]"
  >
    <VText
      :href="url"
      :draggable="false"
      target="_blank"
      tag="a"
      rel="noreferrer"
      class="pl-navigation-link__text"
    >
      <div class="pl-navigation-link__container">
        <component :is="PRODUCT_ICONS[name]" class="pl-navigation-link__icon" />
        <span
          class="pl-navigation-link__label"
          :style="{ color: active ? color : '#717171' }"
          >{{ label }}</span
        >
      </div>
      <span class="pl-navigation-link__border" :style="{ background: color }" />
    </VText>
  </div>
</template>

<style lang="postcss" scoped>
.pl-navigation-link {
  margin-right: 12px;
  position: relative;

  &__active {
    cursor: default;

    .pl-navigation-link__border {
      opacity: 1;
    }
  }
}

.pl-navigation-link__text {
  .pl-navigation & {
    display: flex;
    height: 56px;
    text-decoration: none;
  }
}

.pl-navigation-link__container {
  display: flex;
  align-items: center;
}

.pl-navigation-link__label {
  font: var(--pl-font-body-large-accent);
  padding: 0 5px 0 8px;
  color: inherit;
  user-select: none;
  white-space: nowrap;
}

.pl-navigation-link__border {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.25s;
  height: 2px;

  .pl-navigation-link:hover & {
    opacity: 1;
  }
}
</style>
